
<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
<span *ngIf="setCycleType($.row.clt_subs_billing_interval_type) !=null;else empty">{{setCycleType($.row.clt_subs_billing_interval_type)}}
</span>
 <ng-template #empty>-</ng-template>
 </ng-container>

